import { render } from "./MyPageForm.vue?vue&type=template&id=3579f53e"
import script from "./MyPageForm.vue?vue&type=script&lang=js"
export * from "./MyPageForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__